import {View} from "@lernetz/ts-lib";
import template from './Wizard.html';

export class WizardView extends View {
    constructor() {
        super({template})
    }

}

